/**
 * Use this if you need to a static placeholder value
 */
export const EXAMPLE_LOCALE = 'en-US';

/**
 * @internal Use {@link getDefaultLocale} or {@link EXAMPLE_LOCALE} instead unless you have a good reason to specify American English explicitly as the locale
 */
export const AMERICAN_ENGLISH = 'en-US';

/**
 * Note: Although this is not a constant, it's been added here as a incremental migration off of an old constant called "DEFAULT_LOCALE".
 * This was added to support anonymous mode browser locales.
 *
 * We check for the string literal 'undefined' because an observed behaviour in
 * laywright's Firefox environment
 * sets `navigator.languages: ["undefined"], navigator.language: "undefined"`.
 */
export const getDefaultLocale = () => {
  const locale =
    globalThis.window?.ATLASSIAN_CANVAS?.testingLocale ||
    globalThis.navigator?.languages?.[0];

  return locale && locale !== 'undefined' ? locale : AMERICAN_ENGLISH;
};
